/**
 * Returns the redirect URL for lounge portal based on the current environment.
 * This function centralizes the redirect logic used in both middleware and mixins.
 *
 * @returns {string} The redirect URL for the lounge portal
 */
export function getLoungePortalRedirectUrl(): string {
  const env = process.env.NUXT_ENV_ENVIRONMENT;
  const regex = /^local\.lounge-portal\.partner-\d+\.test\.web\.cavu-tech\.local$/;

  if (typeof window !== 'undefined' && regex.test(window.location.hostname)) {
    return 'http://localhost:3001/lounge-portal';
  }

  if (!env || env === 'live') {
    return 'https://propel.ca.vu/';
  }

  if (['test', 'uat'].includes(env)) {
    return `https://partners.${env}.extranet.cavu-tech.com/`;
  }

  if (env === 'development') {
    return 'https://partners.dev.extranet.cavu-tech.com/';
  }

  // Fallback to live URL
  return 'https://propel.ca.vu/';
}
